var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.606,
    height: 15.198,
    viewBox: "0 0 15.606 15.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "office",
    transform: "translate(-25.98 486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M30.082-485.942c-.187.115-.2.176-.2.957v.716h-.716c-.784,0-.845.014-.96.2-.051.088-.054.614-.054,6.239v6.144h-.916c-1,0-1.042.007-1.184.19a.446.446,0,0,0,.2.648c.173.058,14.89.058,15.063,0a.441.441,0,0,0,.271-.421.335.335,0,0,0-.115-.275l-.115-.125-.97-.01-.97-.01v-6.141c0-5.625,0-6.151-.054-6.239-.115-.19-.176-.2-.96-.2h-.716v-.716c0-.784-.014-.845-.2-.96a27.349,27.349,0,0,0-3.7-.054A27.2,27.2,0,0,0,30.082-485.942Zm6.738,1.232v.424H30.747l-.01-.387a4.272,4.272,0,0,1,.007-.434,26.35,26.35,0,0,1,3.047-.037l3.03.01Zm1.74,7.168.007,5.859h-1.73l0-1.537a13.834,13.834,0,0,0-.041-1.652.471.471,0,0,0-.156-.193l-.115-.078H31.045l-.115.078a.471.471,0,0,0-.156.193,13.832,13.832,0,0,0-.041,1.652l0,1.537H29v-5.845c0-3.216.01-5.859.024-5.869s2.161-.02,4.773-.017l4.753.01Zm-5.218,4.553v1.306h-1.73V-474.3h1.73Zm2.612,0v1.306h-1.73V-474.3h1.73Z",
    transform: "translate(0 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.a2ba2a501f41b5fcbfd5f8e80721c8c9.svg";
export { ForwardRef as ReactComponent };